import {
  LOGIN_FULFILLED,
  LOGIN_REJECTED,
  LOGIN_REQUESTED,
  REGISTER_USER_FULFILLED,
  REGISTER_USER_REJECTED,
  REGISTER_USER_REQUESTED,
  VERIFY_EMAIL_REQUESTED,
  VERIFY_EMAIL_FULFILLED,
  VERIFY_EMAIL_REJECTED,
  POST_SERVICE_ORDER_SUCCESSFULLY,
  RESET_PASSWORD_FULFILLED,
  RESET_PASSWORD_REJECTED,
  RESET_PASSWORD_REQUESTED,
  GET_USER_FULFILLED,
  GET_USER_REQUESTED,
  GET_USER_REJECTED,
  CHECK_EMAIL,
} from '../Actions/types';

const INITIAL_STATE = {
  user: { key: ''},
  email: '',
  loading: false,
  error: '',
  loginError: '',
  resetPasswordError: '',
  registrationError: '',
  emailInUse: false,
}

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case CHECK_EMAIL: 
    return {...state, emailInUse: action.payload }
  case POST_SERVICE_ORDER_SUCCESSFULLY:
    return {...state, email: action.data.email};
  case LOGIN_REQUESTED:
    return { ...state, loading: true, loginError: '', resetPasswordError: '' }
  case LOGIN_REJECTED:
    return { ...state, loginError: action.payload, loading: false }
  case LOGIN_FULFILLED:
    return { ...state, user: action.payload, loginError: '',loading: false, }
  case REGISTER_USER_REQUESTED:
    return { ...state, loading: true, loginError: '', resetPasswordError: '', registrationError: '' }
  case REGISTER_USER_FULFILLED:
    return { ...state, registrationError: '', user: action.payload, loading: false }
  case REGISTER_USER_REJECTED:
    return { ...state, registrationError: action.payload, loading: false }
  case VERIFY_EMAIL_REQUESTED:
    return { ...state, loading: true, error: '' }
  case VERIFY_EMAIL_FULFILLED:
    return { ...state, error: '', user: action.payload, loading: false }
  case VERIFY_EMAIL_REJECTED:
    return { ...state, error: action.payload, loading: false }
  case RESET_PASSWORD_REQUESTED:
    return { ...state, loading: true, resetPasswordError: '', loginError: '' }
  case RESET_PASSWORD_FULFILLED:
    return { ...state, resetPasswordError: '', resetPasswordSent: true, loading: false }
  case RESET_PASSWORD_REJECTED:
    return { ...state, resetPasswordError: action.payload, loading: false }
  case GET_USER_FULFILLED:
    return { ...state, user: {key: state.user.key, ...action.payload}, loading: false, error: ''}
  case GET_USER_REQUESTED:
    return { ...state, loading: true, error: '' }
  case GET_USER_REJECTED:
    return { ...state, error: action.payload, user: { key: '' }, loading: false }
  default:
    return { ...state }
  }
};

export default userReducer;